import { useEffect, useState } from 'react'
import { formatWeekdayDate, STATION_TZ, stationClock } from '../lib/time'

/** Often enough that the minute never reads more than a quarter of a minute
 *  late, rarely enough to cost nothing. */
const TICK_MS = 15_000

/** The header's clock. It replaces the old "all times Asia/Tbilisi" label
 *  and says the same thing twice: by showing station time, and in its title
 *  for anyone who wonders why it is not their own. A screen reader gets the
 *  note as text: an aria-label on a plain span is not read. */
export function StationClock() {
  const [now, setNow] = useState(() => new Date())
  useEffect(() => {
    const timer = window.setInterval(() => setNow(new Date()), TICK_MS)
    return () => window.clearInterval(timer)
  }, [])
  const note = `All times are station-local, ${STATION_TZ}`
  return (
    <span className="mono station-clock" title={note}>
      {stationClock(now)}
      <span className="visually-hidden">. {note}</span>
    </span>
  )
}

/** Today's date in station time, in the header where the search was (Tamar,
 *  2026-10-28). It turns over at station midnight, not the reader's. */
export function StationDate() {
  const [now, setNow] = useState(() => new Date())
  useEffect(() => {
    const timer = window.setInterval(() => setNow(new Date()), TICK_MS)
    return () => window.clearInterval(timer)
  }, [])
  return <span className="ws-date">{formatWeekdayDate(now)}</span>
}
